import { MultiStepInstructionsContextProvider } from '@datacamp/multi-step-instructions';
import * as React from 'react';
import CommunicationContainer from '../containers/CommunicationContainer';
import Exercise from '../containers/Exercise';
import { ConversationalInterfaceStoreProvider } from './Exercise/ConversationalInterfaceLayout/contexts';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Shell = _ref => {
  let {
    callbacks,
    environment,
    exercise,
    id,
    resources,
    user
  } = _ref;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(CommunicationContainer, {
    exercise: exercise,
    exerciseId: id,
    onExerciseReady: callbacks.onExerciseReady,
    onExerciseStatusUpdate: callbacks.onExerciseStatusUpdate,
    onExerciseSubmitted: callbacks.onExerciseSubmitted,
    onXpUpdated: callbacks.onXpUpdated
  }), exercise && ___EmotionJSX(ConversationalInterfaceStoreProvider, {
    exercise: exercise,
    key: id
  }, ___EmotionJSX(MultiStepInstructionsContextProvider, {
    hasQuestionAtTheEnd: true,
    instructionSteps: exercise.instructionSteps,
    xp: exercise.xp
  }, ___EmotionJSX(Exercise, {
    environment: environment,
    exercise: exercise,
    exerciseId: id,
    onExerciseFinished: callbacks.onExerciseFinished,
    onExerciseStatusUpdate: callbacks.onExerciseStatusUpdate,
    resources: resources,
    user: user
  }))));
};
export default Shell;